import HybridMediaBlock from "@/app/(site)/_components/GCSanityBlocks/HybridMediaBlock"

import { type HybridMediaBlockData } from "@/types/gc-modules-types"
import { clsx } from "@/src/utils/clsx"

export interface HybridMediaModuleData {
    _type: string
    _key: string
    hybridMediaBlock: HybridMediaBlockData
    height?: string
}

type HybridMediaProps = {
    data: HybridMediaModuleData
    isAboveTheFold?: boolean
    className?: string
}

export default function HybridMediaModule({
    data,
    isAboveTheFold,
    className
}: HybridMediaProps) {
    if (!data) {
        return null
    }

    const { hybridMediaBlock, height } = data

    if (!hybridMediaBlock) {
        return null
    }

    const {
        mediaBlock,
        contentPlacement = "bottom-left",
        headingBlock,
        textColor,
        link
    } = hybridMediaBlock

    if (!mediaBlock) {
        return null
    }

    // Heights are switched purely with CSS so a single block is rendered (no
    // duplicated desktop/mobile DOM). The mobile/desktop offsets account for the
    // different header heights per breakpoint.
    const wrapperHeight = {
        "100": "h-[calc(100vh-48px)] temp-md:h-[calc(100vh-56px)]",
        "80": "h-[80vh]"
    }

    const responsiveHeight = wrapperHeight[height as keyof typeof wrapperHeight]

    const sectionStyling = clsx("relative w-full", responsiveHeight, className)

    const imageSizes = "(max-width: 1024px) 100vw, 90vw"

    return (
        <section className={sectionStyling}>
            <HybridMediaBlock
                className="h-full"
                isAboveTheFold={isAboveTheFold}
                data={{
                    _type: hybridMediaBlock._type,
                    _key: hybridMediaBlock._key,
                    contentPlacement,
                    headingBlock,
                    isAboveTheFold,
                    mediaBlock,
                    textColor: textColor || "text-main-white",
                    imageSizes,
                    link
                }}
            />
        </section>
    )
}
